import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Chip,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

const DropBagItemsDialog = ({ 
  open, 
  onClose, 
  items, 
  onAddItem, 
  onAddMultipleItems,
  onRemoveItem, 
  stationLocation,
  unit = 'miles'
}) => {
  const [newItem, setNewItem] = useState('');
  
  const handleAddItem = () => {
    if (!newItem.trim()) return;
    
    // Split by comma and filter empty items
    const itemsToAdd = newItem
      .split(',')
      .map(item => item.trim())
      .filter(item => item !== '');
    
    if (itemsToAdd.length === 0) return;
    
    console.log('[DEBUG] Processing items:', itemsToAdd);
    
    // Always use onAddMultipleItems if available, regardless of item count
    if (onAddMultipleItems) {
      console.log('[DEBUG] Using batch add for items');
      onAddMultipleItems(itemsToAdd);
    } else {
      // Fallback to adding items one by one if batch add not available
      console.log('[DEBUG] Fallback: Adding items one by one');
      itemsToAdd.forEach(item => onAddItem(item));
    }
    
    // Clear the input field
    setNewItem('');
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddItem();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Drop Bag Items for {stationLocation} {unit}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Add items that you want to include in this drop bag. You can add multiple items at once by separating them with commas.
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', mb: 2 }}>
          <TextField
            fullWidth
            value={newItem}
            onChange={(e) => setNewItem(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter item(s) - separate multiple items with commas"
            variant="outlined"
            size="small"
          />
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleAddItem}
            disabled={!newItem.trim()}
            sx={{ ml: 1 }}
            startIcon={<AddIcon />}
          >
            Add
          </Button>
        </Box>
        
        {items.length > 0 ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {items.map((item, index) => (
              <Chip
                key={index}
                label={item}
                variant="outlined"
                onDelete={() => onRemoveItem(index)}
              />
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ my: 2, textAlign: 'center' }}>
            No items added yet. Add some items to include in your drop bag.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DropBagItemsDialog; 